import React from 'react';
import { Link } from 'react-router-dom';

// Import elevation images for each home model
// Aurora
import auroraElevA from '../../assets/images/Aurora/Yeremian---Aurora-A-cr (1).jpg';
import auroraElevB from '../../assets/images/Aurora/Yeremian-Aurora-B-cr (1).jpg';
import auroraElevC from '../../assets/images/Aurora/Yeremian--Aurora-C-cr (1).jpg';

// Victoria
import victoriaElevA from '../../assets/images/Victoria/Yeremian--Victoria-A-cr.jpg';
import victoriaElevB from '../../assets/images/Victoria/Yeremian--Victoria-B-cr.jpg';
import victoriaElevC from '../../assets/images/Victoria/Yeremian--Victoria-C-cr.jpg';

// Ceres
import ceresElevA from '../../assets/images/Ceres/Yeremian-Ceres-A-cr (1).jpg';
import ceresElevB from '../../assets/images/Ceres/Yeremian--Ceres-B-cr (2).jpg';
import ceresElevC from '../../assets/images/Ceres/Yeremian-Ceres-C-cr (1).jpg';

// Cybele
import cybeleElevA from '../../assets/images/Cybele/Yeremian-Cybele-A-cr (1).jpg';
import cybeleElevB from '../../assets/images/Cybele/Yeremian-Cybele-B-cr (1).jpg';
import cybeleElevC from '../../assets/images/Cybele/Yeremian-Cybele-C-cr (1).jpg';

// Diana
import dianaElevA from '../../assets/images/Diana/Yeremian-Diana-A-cr (1).jpg';
import dianaElevB from '../../assets/images/Diana/Yeremian--Diana-B-cr (1).jpg';
import dianaElevC from '../../assets/images/Diana/Yeremian-Diana-C-cr (1).jpg';

// Pomona
import pomonaElevA from '../../assets/images/Pomona/Yeremian--Pomona-A-cr.jpg';
import pomonaElevB from '../../assets/images/Pomona/Yeremian--Pomona-B-cr.jpg';
import pomonaElevC from '../../assets/images/Pomona/Yeremian--Pomona-C-cr.jpg';

// Terra
import terraElevA from '../../assets/images/Terra/Yeremian--Terra-A-cr.jpg';
import terraElevB from '../../assets/images/Terra/Yeremian-Terra-B-cr.jpg';
import terraElevC from '../../assets/images/Terra/Yeremian-Terra-C-cr.jpg';

// Vesta
import vestaElevA from '../../assets/images/Vesta/Yeremian--Vesta-A-cr.jpg';
import vestaElevB from '../../assets/images/Vesta/Yeremian--Vesta-B-cr.jpg';
import vestaElevC from '../../assets/images/Vesta/Yeremian--Vesta-C-cr.jpg';

// This would typically come from an API or database
const homes = [
  {
    id: 'aurora',
    name: 'Aurora',
    description: 'Our Aurora plan offers three exterior options to choose from and a two-story floor plan with 4 bedrooms and 3.5 bathrooms. The open concept main level features a spacious living room and a dining room.',
    elevations: [auroraElevA, auroraElevB, auroraElevC],
    bedrooms: 4,
    bathrooms: 3.5,
    sqft: 2800
  },
  {
    id: 'victoria',
    name: 'Victoria',
    description: 'The Victoria plan features three exterior options and a spacious two-story layout with 4 bedrooms and 4 bathrooms. The main level boasts an open-concept design, including a living room, dining room, and a luxurious master suite.',
    elevations: [victoriaElevA, victoriaElevB, victoriaElevC],
    bedrooms: 4,
    bathrooms: 4,
    sqft: 3100
  },
  {
    id: 'ceres',
    name: 'Ceres',
    description: 'The Ceres floorplan offers a stylish and practical design with versatile spaces to meet the needs of any family. The main level features a spacious office, a cozy master suite, and a versatile flex room.',
    elevations: [ceresElevA, ceresElevB, ceresElevC],
    bedrooms: 3,
    bathrooms: 2.5,
    sqft: 2500
  },
  {
    id: 'cybele',
    name: 'Cybele',
    description: 'The Cybele floorplan offers a unique and functional design with spacious living areas and private bedrooms. On the main level, the luxurious master suite is complemented by two additional bedrooms with a shared jack-and-jill bathroom.',
    elevations: [cybeleElevA, cybeleElevB, cybeleElevC],
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2900
  },
  {
    id: 'diana',
    name: 'Diana',
    description: 'The Diana floorplan is a beautiful and functional two-story home with plenty of living space for families. The main level features a spacious living room and dining room, perfect for entertaining and relaxing.',
    elevations: [dianaElevA, dianaElevB, dianaElevC],
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2700
  },
  {
    id: 'pomona',
    name: 'Pomona',
    description: 'The Pomona floorplan is a stunning two-story home with a spacious and functional layout. The main level features a luxurious master suite, a large great room, and a dining room, perfect for entertaining or relaxing with family.',
    elevations: [pomonaElevA, pomonaElevB, pomonaElevC],
    bedrooms: 4,
    bathrooms: 3.5,
    sqft: 3000
  },
  {
    id: 'terra',
    name: 'Terra',
    description: 'The Terra floorplan offers a versatile and functional design, perfect for families seeking a comfortable and spacious living space. The main level features a luxurious master suite and two additional bedrooms.',
    elevations: [terraElevA, terraElevB, terraElevC],
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2600
  },
  {
    id: 'vesta',
    name: 'Vesta',
    description: 'The Vesta floorplan is a tasteful and inviting two-story home that provides a warm and comfortable living experience. The main level features a spacious dining and family room, along with a convenient half bath.',
    elevations: [vestaElevA, vestaElevB, vestaElevC],
    bedrooms: 4,
    bathrooms: 2.5,
    sqft: 2400
  }
];

// Function to get elevation based on index (A=0, B=1, C=2, then cycles back)
const getElevationForIndex = (elevations: string[], index: number): string => {
  return elevations[index % 3];
};

const Homes: React.FC = () => {
  return (
    <div className="container-custom py-12 md:py-24">
      <h1 className="mb-8 text-center">Our Homes</h1>
      <div className="max-w-5xl mx-auto">
        <p className="text-lg text-gray-700 mb-12 text-center max-w-3xl mx-auto">
          Explore our thoughtfully designed home plans with beautiful elevations and endless possibilities for your dream home.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {homes.map((home, index) => (
            <div key={home.id} className="bg-white rounded-lg shadow-md overflow-hidden group hover:shadow-xl transition duration-300">
              <Link to={`/homes/${home.id}`}>
                <div className="relative h-56 overflow-hidden">
                  <img 
                    src={getElevationForIndex(home.elevations, index)} 
                    alt={`${home.name} - Elevation ${String.fromCharCode(65 + (index % 3))}`} 
                    className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition duration-300"></div>
                  <div className="absolute top-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">
                    Elevation {String.fromCharCode(65 + (index % 3))}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-serif text-dark mb-2">{home.name}</h3>
                  <div className="flex justify-between text-sm text-gray-600 mb-3">
                    <span>{home.bedrooms} Beds</span>
                    <span>{home.bathrooms} Baths</span>
                    <span>{home.sqft} sqft</span>
                  </div>
                  <p className="text-gray-600 line-clamp-3">{home.description}</p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Homes; 